// This extraction is because of the BuilderMobileApi requirement of only pure functions
import { FlowStore } from '~/stores/flow.store';
import { FlowService } from '~/services/flow.service';
import { FullstoryService } from '~/services/fullstory/fullstory.service';
import { ToastStore } from '~/stores/toast.store';
import { useHistory } from 'react-router';
import { LogEvents } from '~/services/fullstory/log-events';
import { ToastType } from '@honeybook/hbui/dist/components/HBToast/HBToast.types';
import TrashIcon from '@honeybook/icons/dist/icons/Trash24';
import colors from '@honeybook/hbui/dist/styles/colors';
import { goToFlow } from '~/components/Builder/Common/useFlowNavigation';
import { FlowRouteType } from '~/utils/flow.utils';

// Extracted this function to it's own file to prevent circular deps.
export async function removeScheduleSend({
    flowId,
    flowService,
    flowStore,
    toastStore,
    fullstoryService,
    history
}: {
    flowStore: FlowStore;
    flowId: string;
    flowService: FlowService;
    fullstoryService: FullstoryService;
    toastStore: ToastStore;
    history: ReturnType<typeof useHistory>;
}) {
    const flow = flowStore.flows[flowId];

    // TODO: error handling. get back true/false if successful. & add try/catch block.
    await flowService.removeScheduleSend(flowId);

    fullstoryService.debug(LogEvents.RemovedScheduleSend);
    flow.setScheduleSend(null);
    flow.clearShareFlowPendingTask();
    toastStore.add({
        type: ToastType.Success,
        autoDismissMs: 6000,
        text: `Scheduled send of ${flow.title} file was removed`,
        icon: TrashIcon,
        iconColor: colors.black
    });

    if (!flow.is_published) {
        goToFlow({
            flowId,
            history,
            forceRoute: FlowRouteType.edit
        });
    }
}
